import * as CONST from '../../../constants';

const INITIAL_STATE = { loading: true, order: null, error: null };

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case CONST.SUBSCRIPTION_ORDER_EDIT_REQUEST:
      return { ...INITIAL_STATE, loading: true, order: null, error: null };
    case CONST.SUBSCRIPTION_ORDER_EDIT_SUCCESS:
      return { ...INITIAL_STATE, loading: false, order: action.order, error: null };
    case CONST.SUBSCRIPTION_ORDER_EDIT_ERROR:
      return { ...INITIAL_STATE, loading: false, error: action.error, order: null };
    case CONST.CLOSE_MODAL:
      return { ...INITIAL_STATE, loading: false, error: null, order: null };
    default:
      return state;
  }
};
